module.exports = __webpack_public_path__ + "assets/JTUSjIg1_i6t8kCHKm459W1hyzbi-26fcda.woff2";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/GoogleFonts/JTUSjIg1_i6t8kCHKm459W1hyzbi.woff2
// module id = 845
// module chunks = 2